import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const CollectionStateContext = createContext();

export const CollectionStateProvider = ({ children }) => {
  const [collectionsState, setCollectionsState] = useState({});
  const setOpen = useCallback(
    (id, open) =>
      setCollectionsState({
        ...collectionsState,
        [id]: open,
      }),
    [collectionsState]
  );
  const value = useMemo(() => ({ collectionsState, setOpen }), [collectionsState, setOpen]);

  return <CollectionStateContext.Provider value={value}>{children}</CollectionStateContext.Provider>;
};

export const useCollectionsStateContext = () => useContext(CollectionStateContext);
